import { cn } from '@/lib/cn'

export function ProgressBar({
  value,
  className,
  tone = 'brand',
  label,
}: {
  value: number
  className?: string
  tone?: 'brand' | 'success'
  label?: string
}) {
  const safe = Math.min(100, Math.max(0, Math.round(value)))

  return (
    <div
      role="progressbar"
      aria-valuenow={safe}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label ?? 'Kemajuan'}
      className={cn('h-2 w-full overflow-hidden rounded-full bg-sunken', className)}
    >
      <div
        className={cn(
          'h-full rounded-full transition-[width] duration-500',
          tone === 'success' ? 'bg-success' : 'bg-brand',
        )}
        style={{ width: `${safe}%` }}
      />
    </div>
  )
}

/** ProgressRing dipakai pada kartu kelas: persentase terbaca sekali lihat. */
export function ProgressRing({ value, size = 44 }: { value: number; size?: number }) {
  const safe = Math.min(100, Math.max(0, Math.round(value)))
  const stroke = 4
  const radius = (size - stroke) / 2
  const circumference = 2 * Math.PI * radius

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img" aria-label={`Kemajuan ${safe} persen`}>
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke="var(--border)"
        strokeWidth={stroke}
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke={safe === 100 ? 'var(--success)' : 'var(--brand)'}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={circumference - (safe / 100) * circumference}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        style={{ transition: 'stroke-dashoffset 600ms var(--ease-out-soft)' }}
      />
      <text
        x="50%"
        y="50%"
        dominantBaseline="central"
        textAnchor="middle"
        fontSize={size / 3.6}
        fontWeight="700"
        fill="var(--ink)"
      >
        {safe}
      </text>
    </svg>
  )
}
